import { Transaction, TransactionType } from '../../../../graphql'

export type PartialTransaction = Pick<Transaction, 'transactionType' | 'fromId' | 'toId'>

export default function groupTransactions( data?: { transactions?: PartialTransaction[] | null } ) {
	const result: {
		[ key in TransactionType ]?: {
			fromIds: number[],
			toIds: number[],
		}
	} = {}
	let count = 0

	if ( data?.transactions?.length ) {
		const transactions = data.transactions

		for ( const t of transactions ) {
			if ( t.transactionType ) {
				if ( !result[ t.transactionType ] ) {
					result[ t.transactionType ] = {
						fromIds: [],
						toIds: [],
					}
				}
				result[ t.transactionType ]?.fromIds.push( t.fromId )
				result[ t.transactionType ]?.toIds.push( t.toId )
			}
		}
		count = transactions.length
	}

	return {
		count,
		transactions: result,
	}
}
